
(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-menu-toggle]');
    if (button) {
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
    }
    if (event.target.closest('[data-mobile-menu] a')) {
      document.querySelectorAll('[data-mobile-menu]').forEach(menu => { menu.hidden = true; });
      document.querySelectorAll('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-mobile-menu]').forEach(menu => { menu.hidden = true; });
      document.querySelectorAll('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-wow-form]')) return;
    if (event.defaultPrevented) return;
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
    const button = form.querySelector('button[type="submit"]');
    if (button) { button.setAttribute('aria-busy','true'); button.textContent = form.dataset.sending || button.textContent; }
  });
})();

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const section = event.target.closest('.commerce-page');
  if (!option || !section) return;
  const price = section.querySelector('.product-price');
  const button = section.querySelector('button[name="add"]');
  if (price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    if (!button.disabled) button.textContent = button.dataset.addLabel;
  }
});
(() => {
  const storageKey = () => 'wow-native-submission:' + window.location.pathname;
  function readSubmittedMode() {
    try { return window.sessionStorage.getItem(storageKey()); } catch { return null; }
  }
  function rememberSubmission(mode) {
    try { window.sessionStorage.setItem(storageKey(), mode); } catch { /* Storage can be unavailable. */ }
  }

  function setMode(section, requestedMode, updateUrl = false) {
    const mode = requestedMode === 'contact' ? 'contact' : 'moment';
    const suffix = mode === 'contact' ? 'Contact' : 'Moment';
    const form = section.querySelector('[data-wow-form]');
    if (!form || form.querySelector('button[aria-busy="true"]')) return;
    const app = section.querySelector('[data-wow-story-app]');
    const nativeMode = app ? 'contact' : mode;
    const nativeSuffix = nativeMode === 'contact' ? 'Contact' : 'Moment';
    if (app) app.hidden = mode !== 'moment';
    const nativePanel = section.querySelector('[data-wow-native-panel]');
    if (nativePanel) nativePanel.hidden = Boolean(app && mode === 'moment');
    else form.hidden = Boolean(app && mode === 'moment');
    section.dataset.currentMode = mode;
    section.querySelectorAll('[data-form-mode]').forEach(button => {
      const active = button.dataset.formMode === mode;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    [
      ['[data-mode-heading]', 'title', suffix],
      ['[data-mode-intro]', 'intro', suffix],
      ['[data-mode-message]', 'label', nativeSuffix],
      ['[data-mode-submit]', 'submit', nativeSuffix],
    ].forEach(([selector, prefix, fieldSuffix]) => {
      const element = section.querySelector(selector);
      if (element) {
        const value = element.dataset[prefix + fieldSuffix];
        element.textContent = selector === '[data-mode-message]' ? value + ' *' : value;
      }
    });
    const message = section.querySelector('[data-mode-placeholder]');
    if (message) message.placeholder = message.dataset['placeholder' + nativeSuffix];
    const kind = form.querySelector('input[name="contact[Submission type]"]');
    if (kind) kind.value = nativeMode;
    [['[data-moment-only]', nativeMode === 'moment'], ['[data-contact-only]', nativeMode === 'contact']].forEach(([selector, visible]) => {
      section.querySelectorAll(selector).forEach(group => {
        group.hidden = !visible;
        group.querySelectorAll('input, select, textarea').forEach(field => { field.disabled = !visible; });
      });
    });
    const credit = section.querySelector('[data-mode-credit]');
    if (credit) credit.hidden = mode === 'contact';
    const url = new URL(window.location.href);
    if (mode === 'contact') url.searchParams.set('type', 'contact');
    else url.searchParams.delete('type');
    if (updateUrl) {
      url.searchParams.delete('contact_posted');
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
    const returnTo = url.pathname + url.search;
    const formReturn = form.querySelector('input[name="return_to"]');
    if (formReturn) formReturn.value = returnTo;
    document.querySelectorAll('form[action*="localization"] input[name="return_to"]').forEach(input => { input.value = returnTo; });
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-wow-mode-section]').forEach(section => {
      const url = new URL(window.location.href);
      let mode = url.searchParams.get('type') === 'contact' ? 'contact' : section.dataset.initialMode;
      // This node exists only when Shopify reports a successful native submission.
      const success = section.querySelector('[data-wow-submitted-success]');
      const errors = section.querySelector('[data-wow-native-errors]');
      if (errors && !success) {
        const stored = readSubmittedMode();
        const submitted = url.searchParams.get('type') === 'contact' ? 'contact' : (stored || errors.dataset.defaultSubmission);
        mode = submitted === 'contact' ? 'contact' : 'moment';
      }
      if (success) {
        const stored = readSubmittedMode();
        const submitted = url.searchParams.get('type') === 'contact' ? 'contact' : (stored === 'contact' || stored === 'moment' ? stored : success.dataset.defaultSubmission);
        const submittedMode = submitted === 'contact' ? 'contact' : 'moment';
        success.textContent = success.dataset[submittedMode === 'contact' ? 'successContact' : 'successMoment'];
        mode = submittedMode;
        // Do not rewrite this success message when the visitor changes tabs.
        if (typeof success.focus === 'function') success.focus({ preventScroll: true });
        if (typeof success.scrollIntoView === 'function') success.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      setMode(section, mode);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-form-mode]');
    if (!button) return;
    const section = button.closest('[data-wow-mode-section]');
    if (section) setMode(section, button.dataset.formMode, true);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-wow-form]')) return;
    if (event.defaultPrevented || !event.target.checkValidity()) return;
    const kind = event.target.querySelector('input[name="contact[Submission type]"]');
    if (kind) rememberSubmission(kind.value === 'contact' ? 'contact' : 'moment');
    const section = event.target.closest('[data-wow-mode-section]');
    if (section) section.querySelectorAll('[data-form-mode]').forEach(button => { button.disabled = true; });
  });
})();
(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-wow-story-app]').forEach(panel => {
      if (panel.dataset.loaderAttached) return;
      panel.dataset.loaderAttached = 'true';
      const widget = panel.querySelector('[data-wow-app-widget]');
      const loading = panel.querySelector('[data-app-loading]');
      const unavailable = panel.querySelector('[data-app-unavailable]');
      if (!widget) return;
      let timeout;
      let observer;
      const ready = () => {
        if (!panel.querySelector('form, input, textarea, iframe')) return false;
        if (loading) loading.hidden = true;
        if (unavailable) unavailable.hidden = true;
        if (timeout) window.clearTimeout(timeout);
        if (observer) observer.disconnect();
        return true;
      };
      if (ready()) return;
      observer = new MutationObserver(ready);
      observer.observe(panel, { childList: true, subtree: true });
      timeout = window.setTimeout(() => {
        if (!ready()) {
          if (loading) loading.hidden = true;
          if (unavailable) unavailable.hidden = false;
          // Keep observing so a slow but successful app load can recover.
        }
      }, 20000);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
